/* eslint-disable */
import React, { memo, useEffect, useState } from 'react'
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { ApplicationConfigurationKeys, DAYS, ENTITYNAME, MEDIACATEGORIES, MEDIACATEGORYTYPES, MILLISECONDSINADAY, TOAST_TYPES } from "../../framework/constant/constant";
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from '../../locale/useTranslation';
import CancelButton from '../../framework/forms/helpercomponents/buttons/CancelButton';
import moment from 'moment';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import BossDialog from '../../components/BossDialog';
import { utility } from '../../framework/utility/utilityProvider';
import { TimeRangePicker } from '../../framework/forms/helpercomponents/timepicker/TimeRangePicker';
import { TimePickerWithFormat } from '../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import SaveButton from '../../framework/forms/helpercomponents/buttons/SaveButton';
import RecursiveTemplatePopup from './RecursiveTemplatePopup';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import ToastNotification from '../../components/ToastNotification';

export const Recursive = memo((props) => {
    const lang = useTranslation();
    //const frmDate = new Date(props.selectedAppointment.SlotDateTime);

    const enableCreateRepPatFromRec = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.EnableCreateRepPatFromRec) ?? false;
    const slotDay = new Date(props.selectedAppointment.SlotDateTime).getUTCDay();
    const [dataItem, setDataItem] = useState({
        FromDate: utility.convertMilisecondsToDateString(props.selectedAppointment.SlotDateTime),
        ToDate: utility.convertMilisecondsToDateString(props.selectedAppointment.SlotDateTime + (7 * MILLISECONDSINADAY)),
        ExcludeFromDate: "",
        ExcludeToDate: "",
        EpisodeRange: "",
        ExcludeDays: false,
        Days: (slotDay != undefined && slotDay != null && slotDay > -1) ? [DAYS.find(x => x.ID === slotDay)] : [],
        ExclusionDays: [],
        LoopTillEndDate: false,
        TwoEpisodePerDay: false,
        NoOfEpisodesPerDay: 1,
        RepeatPattern: { Name: "" },
        ProgramGroup: { Name: "" },
        IsCustomDuration: false,
        CustomDuration: null,
        AutoDeleteStartAndEndCredits: false
    });
    const [openRepeatPatternSelection, setOpenRepeatPatternSelection] = useState(false);
    const [openProgramGroupSelection, setOpenProgramGroupSelection] = useState(false);
    const [selectAllDays, setSelectAllDays] = useState(false);
    const [selectAllInclusiveDays, setSelectAllInclusiveDays] = useState(false);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const [timeBlocks, setTimeBlocks] = useState([0, 1, 2]);
    const [repeatPatternData, setRepeatPatternData] = useState({});
    const [freshRepeatPattern, setFreshRepeatPattern] = useState([]);
    const [showRecursiveTemplatePopup, setShowRecursiveTemplatePopup] = useState({
        show: false,
        forLoad: false,
        data: null
    });

    useEffect(() => { }, []);

    const onChange = (e) => {

        if (e.target.name == "LoopTillEndDate") {
            setDataItem({ ...dataItem, LoopTillEndDate: !dataItem.LoopTillEndDate });
        }
        else if (e.target.name == "TwoEpisodePerDay") {
            setDataItem({ ...dataItem, TwoEpisodePerDay: !dataItem.TwoEpisodePerDay });
        }
        else if (e.target.name == "ExcludeDays") {
            setDataItem({
                ...dataItem,
                ExcludeDays: !dataItem.ExcludeDays,
                Days: dataItem.ExcludeDays && slotDay ? [DAYS.find(x => x.ID === slotDay)] : []
            });
        }
        else if (e.target.name == "Days") {
            if (e.target.value.length == DAYS.length) {
                setDataItem({ ...dataItem, Days: DAYS });
                setSelectAllInclusiveDays(true);
            } else {
                setDataItem({ ...dataItem, Days: e.target.value });
                setSelectAllInclusiveDays(false);
            }
        }
        else if (e.target.name == "ExclusionDays") {
            if (e.target.value.length == DAYS.length) {
                setDataItem({ ...dataItem, ExclusionDays: DAYS });
                setSelectAllDays(true);
            }
            else {
                setDataItem({ ...dataItem, ExclusionDays: e.target.value });
                setSelectAllDays(false);
            }
        } else if (e.target.name == "IsCustomDuration") {
            setDataItem({ ...dataItem, IsCustomDuration: !dataItem.IsCustomDuration });
        } else if (e.target.name == "AutoDeleteStartAndEndCredits") {
            setDataItem({ ...dataItem, AutoDeleteStartAndEndCredits: !dataItem.AutoDeleteStartAndEndCredits });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const onSelectRepeatPattern = () => {
        setOpenRepeatPatternSelection(true)
    }

    const onSetSelectedRepeatPattern = (dataList) => {
        setDataItem({ ...dataItem, RepeatPattern: dataList[0] })
    }

    const onSetSelectedProgramGroup = (dataList) => {
        setDataItem({ ...dataItem, EpisodeRange: "", ProgramGroup: dataList[0] })
    }

    const borderWithTitle = {
        position: "relative", fontSize: "12px",
        top: "-0.9em", marginLeft: "0.8em", display: "inline", backgroundColor: "white"
    };

    const onApplyRecursion = () => {
        if (dataItem.ToDate === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.to_date_is_mandatory_recursive_error_message });
            return;
        }

        if (new Date(dataItem.ToDate) < new Date(props.selectedAppointment.SlotDateTime)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.to_date_should_be_greater_than_base_program_start_date_recursive_error_message });
            return;
        }


        if (selectAllDays) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.all_days_can_not_be_selected_error_message });
            return;
        }

        if (dataItem.IsCustomDuration && dataItem.NoOfEpisodesPerDay == 1 && (!dataItem.CustomDuration || utility.convertStringTimeToMilliseconds(dataItem.CustomDuration) == 0 || utility.convertStringTimeToMilliseconds(dataItem.CustomDuration) < 5 * 60 * 1000)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: utility.convertStringTimeToMilliseconds(dataItem.CustomDuration) < 5 * 60 * 1000 ? lang.please_enter_custom_duration_min_time_error_message : lang.please_enter_custom_duration_error_message });
            return;
        }
        
        // Validation for comma separated durations when NoOfEpisodesPerDay is greater than 1
        if (dataItem.IsCustomDuration && dataItem.NoOfEpisodesPerDay > 1 && dataItem.CustomDuration) {

            const durations = dataItem.CustomDuration.split(',').map(d => d.trim());
            if(durations.length > dataItem.NoOfEpisodesPerDay) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.number_of_episode_not_eqaul_error_message });
                return;
            }

            const hasInvalidDuration = durations.some(d => { return d === '' || isNaN(Number(d)) || Number(d) <= 5});
            if (hasInvalidDuration) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_custom_duration_recusive_error_message });
                return;
            }

        }

        let updatedFreshRepeatPattern = [];

        if (repeatPatternData?.showRepeatPattern) {
            const hasTime = days.some((day) => {
                return (
                    repeatPatternData[`${day}time`] ||
                    timeBlocks.some((block) => repeatPatternData[`${day}_time_${block}`])
                );
            });

            if (!hasTime) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter at least one value to apply repeat pattern" });
                return;
            }

            updatedFreshRepeatPattern = generateSchedule(repeatPatternData);

            if (!Array.isArray(updatedFreshRepeatPattern) || updatedFreshRepeatPattern.length === 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Invalid repeat pattern schedule. Please verify inputs." });
                return;
            }
        }

        let payload = { ...dataItem, CustomDuration: dataItem.IsCustomDuration ? dataItem.CustomDuration : null };

        if (dataItem.ProgramGroup && Object.keys(dataItem.ProgramGroup).length < 2 && props.selectedAppointment.mediaEpisode?.MediaCategory?.SID != MEDIACATEGORIES.Episode) {
            payload = { ...dataItem, ProgramGroup: { _id: "unk", SID: 0, Name: "unk", MediaEpisodes: [props.selectedAppointment.mediaEpisode._id] } }
        }

        if (enableCreateRepPatFromRec && repeatPatternData?.showRepeatPattern) {
            payload = { ...payload, RepeatPattern: { _id: "unk", SID: 0, Name: "unk", Description: "unk", Channel: props?.selectedAppointment?.Channel, Data: updatedFreshRepeatPattern } }
        }

        console.log(payload)
        props.onGenerateRecursion(payload);
    };

    const allDaySelect = (e) => {
        if (e.target.checked) {
            setDataItem({ ...dataItem, ExclusionDays: DAYS });
            setSelectAllDays(true);
        }
        else {
            setDataItem({ ...dataItem, ExclusionDays: [] });
            setSelectAllDays(false);
        }
    }

    const allInclusiveDaySelect = (e) => {
        if (e.target.checked) {
            setDataItem({ ...dataItem, Days: DAYS });
            setSelectAllInclusiveDays(true);
        }
        else {
            setDataItem({ ...dataItem, Days: [] });
            setSelectAllInclusiveDays(false);
        }
    }

    // const getNextDay = (day) => {
    //     const idx = days.indexOf(day);
    //     return days[(idx + 1) % 7];
    // };

    const getNextDay = (day) => {

        const idx = days.indexOf(day);

        // Valid short names from selected days
        const validDays = dataItem.Days.map(d => d.SubName);

        // Find next valid day
        for (let i = 1; i <= 7; i++) {
            const nextDay = days[(idx + i) % 7];

            if (validDays.includes(nextDay)) {
                return nextDay;
            }
        }

        // fallback
        return day;
    };

    const convertTimeToMilliseconds = (hhmm) => {
        if (!hhmm) return 0;
        const [h, m] = hhmm.split(":").map(Number);
        return (h * 60 + m) * 60000;
    };

    const generateSchedule = (formData) => {
        let result = [];
        let primaryIndex = 1;

        for (let day of days) {
            const mainTime = formData[`${day}time`];
            let count = mainTime ? 1 : 0;

            for (let block of timeBlocks) {
                if (formData[`${day}_time_${block}`]) {
                    count++;
                }
            }

            if (mainTime) {
                result.push({
                    _id: `${primaryIndex}_0`,
                    Type: "Primary",
                    PrimaryEventsNo: primaryIndex,
                    RepeatEventsNo: 0,
                    Days: day,
                    NominalStart: convertTimeToMilliseconds(mainTime)
                });

                for (let i = 0; i < timeBlocks.length; i++) {
                    const block = timeBlocks[i];
                    const repeatTime = formData[`${day}_time_${block}`];
                    const isRepeat = formData[`${day}_repeat_${block}`];
                    const nextDay = formData[`${day}_nextDay_${block}`];

                    if (repeatTime && isRepeat) {
                        result.push({
                            _id: `${primaryIndex}_${i + 1}`,
                            Type: "Repeat",
                            PrimaryEventsNo: primaryIndex,
                            RepeatEventsNo: i + 1,
                            Days: nextDay ? getNextDay(day) : day,
                            NominalStart: convertTimeToMilliseconds(repeatTime)
                        });
                    }
                }

                primaryIndex++;
            }
        }
        setFreshRepeatPattern(result)
        return result;
    };

    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        const updated = { ...repeatPatternData };

        const selectAllRepeatMatch = name.match(/^SelectAllRepeat_block_(\d+)$/);
        const selectAllNextDayMatch = name.match(/^SelectAllNextDay_block_(\d+)$/);

        if (selectAllRepeatMatch) {
            const blockIndex = selectAllRepeatMatch[1];
            updated[name] = checked;
            days.forEach((day) => {
                updated[`${day}_repeat_${blockIndex}`] = checked;
            });
        } else if (selectAllNextDayMatch) {
            const blockIndex = selectAllNextDayMatch[1];
            updated[name] = checked;
            days.forEach((day) => {
                updated[`${day}_nextDay_${blockIndex}`] = checked;
            });
        } else {
            updated[name] = type === "checkbox" ? checked : value;
        }

        setRepeatPatternData(updated);
        if (updated.showRepeatPattern) {
            generateSchedule(updated);
        }
    };

    const handleTimeAutoFormat = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/\D/g, '');
        let formatted = numericValue;
        if (numericValue.length > 2) {
            formatted = numericValue.slice(0, 2) + ':' + numericValue.slice(2, 4);
        }
        if (formatted.length > 5) {
            formatted = formatted.slice(0, 5);
        }
        setRepeatPatternData({ ...repeatPatternData, [name]: formatted });
    };

    const onSaveAsTemplate = () => {
        setShowRecursiveTemplatePopup({ show: true, forLoad: false, data: repeatPatternData });
    }

    const onLoadFromTemplate = () => {
        setShowRecursiveTemplatePopup({ show: true, forLoad: true, data: null });
    }

    const onRecursiveTemplateSelect = (template) => {
        if (template?.data) {
            setRepeatPatternData(template.data);
            setShowRecursiveTemplatePopup({ show: false, forLoad: false, data: null });
        }
    }

    return (
        <BossDialog
            title={lang.recursive_dialog_header + " - " + props.selectedAppointment.Title}
            onClose={props.closeForm}
            width={"900px"}
        >
            <div className="row">
                <div style={{ marginLeft: "05px" }}>
                    <ActionButton title={lang.apply_button_tooltip} btnColor={"success"} name={lang.apply_button_text} onClick={onApplyRecursion} />
                    <CancelButton onClick={() => props.closeForm(dataItem)} />
                </div>
            </div>
            <div className='row mt-4'>
                <div className='col-6'>
                    <div style={{ margin: "0px 0px 0px 0px", border: '1px solid #c4c2c2', borderRadius: '5px!important' }}>
                        <div style={borderWithTitle}>&nbsp; {lang.inclusion_range_label} &nbsp;</div>
                        <div className='row mr-1 ml-1'>
                            <div className='col-6'>
                                <div className="form-group">
                                    <label htmlFor="">{lang.from_date_label}</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="FromDate"
                                        disabled={true}
                                        defaultValue={dataItem.FromDate}
                                        value={dataItem.FromDate}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className="form-group">
                                    <label htmlFor="">{lang.to_date_label}</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="ToDate"
                                        value={dataItem.ToDate}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='row mr-1 ml-1'>
                            <div className='col-12'>
                                <div className="form-group">
                                    <span className="float-right">{lang.select_all_label}
                                        <input
                                            type={"checkbox"}
                                            name={"SelectAll"}
                                            className="ml-1"
                                            onChange={allInclusiveDaySelect}
                                            checked={selectAllInclusiveDays}
                                            value={selectAllInclusiveDays}
                                            disabled={dataItem.ExcludeDays}
                                        />
                                    </span>
                                    <label htmlFor="TabView">{lang.days_label}</label>
                                    <MultiSelect
                                        style={{ height: "52px", overflow: "auto", backgroundColor: !dataItem.Days ? '#E9ECEF' : "white" }}
                                        data={DAYS}
                                        name="Days"
                                        textField="Name"
                                        dataItemKey="ID"
                                        value={dataItem.Days}
                                        onChange={onChange}
                                        validator={(value) => value ? "" : "Please select the value"}
                                        disabled={dataItem.ExcludeDays}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='row mr-1 ml-1'>
                            <div className='col-6'>
                                <label htmlFor="">{lang.episode_range_label}</label>
                                <input type="text" className="form-control form-control-sm" name="EpisodeRange" value={dataItem.EpisodeRange || ""} onChange={(e) => onChange(e)} disabled={Object.keys(dataItem.ProgramGroup).length > 1} />
                                <p className="text-muted" style={{ fontSize: "9px", margin: '0px' }}>{lang.example_label}: (1-3)</p>
                            </div>
                            {/* <div className='col-6' style={{ marginTop: '25px' }}>
                                <input name={"TwoEpisodePerDay"} onChange={onChange} type={"Checkbox"} value={dataItem.TwoEpisodePerDay} style={{ width: '15px', height: '15px' }} />
                                <span htmlFor="TabView" className="pl-2" style={{}}>{lang.two_epiosde_per_day_label}</span>
                                <p className="text-muted" style={{ fontSize: "9px", margin: '0px' }}>Note - {lang.two_epiosde_per_day_label}</p>
                            </div> */}
                            <div className='col-6'>
                                <label htmlFor="">{"No of Episodes Per Day"}</label>
                                <input type="number" min="1" className="form-control form-control-sm" name="NoOfEpisodesPerDay" value={dataItem.NoOfEpisodesPerDay || ""} onChange={(e) => onChange(e)} disabled={Object.keys(dataItem.ProgramGroup).length > 1} />
                            </div>
                        </div>
                        <div className='row mr-1 ml-1 mt-1'>
                            <div className="col-6">
                                <div className="d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        name="LoopTillEndDate"
                                        checked={dataItem.LoopTillEndDate || false}
                                        onChange={onChange}
                                        style={{ width: "15px", height: "15px" }}
                                    />

                                    <span className="pl-2">
                                        Loop
                                    </span>
                                </div>
                                <p
                                    className="text-muted mb-0 mt-1"
                                    style={{ fontSize: "9px" }}
                                >
                                    {lang.loop_till_selected_end_date}
                                </p>
                            </div>
                            <div className="col-6">
                                <div className="d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        name="IsCustomDuration"
                                        checked={dataItem.IsCustomDuration || false}
                                        onChange={onChange}
                                        style={{ width: "15px", height: "15px" }}
                                    />

                                    <span className="pl-2">
                                        {lang.custom_slot_duration}
                                    </span>
                                </div>

                                {dataItem.IsCustomDuration && (
                                    <div className="mt-2">
                                        {dataItem.NoOfEpisodesPerDay > 1 ? 
                                        <div className='col' style={{ padding: 0 }}>
                                            <input type="text" className="form-control form-control-sm" name="CustomDuration" value={dataItem.CustomDuration} onChange={onChange} />
                                            <p className="text-muted" style={{ fontSize: "8.5px", margin: '0px' }}>{lang.enter_comma_separated_durations_error_message}</p>
                                        </div>
                                            : 
                                        <>
                                            <TimePickerWithFormat className="form-control form-control-sm" name="CustomDuration" value={dataItem.CustomDuration} onChange={onChange} />
                                            <p className="text-muted" style={{ fontSize: "9px", margin: '0px' }}>{lang.duration_format_note}</p>
                                        </>}
                                    </div>
                                )}
                            </div>


                        </div>

                        {dataItem.NoOfEpisodesPerDay > 1 && <div className='row mr-1 ml-1 mt-2'>
                            <div className="col">
                                <div className="d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        name="AutoDeleteStartAndEndCredits"
                                        checked={dataItem.AutoDeleteStartAndEndCredits || false}
                                        onChange={onChange}
                                        style={{ width: "15px", height: "15px" }}
                                    />

                                    <span className="pl-2">
                                        {lang.auto_delete_start_end_credits_label}
                                    </span>
                                </div>
                                <p
                                    className="text-muted mb-0 mt-1"
                                    style={{ fontSize: "9px" }}
                                >
                                    {lang.delete_start_end_credits_note_message}
                                </p>
                            </div>
                        </div>}

                        <div className='row mr-1 ml-1 mt-1'>
                            <div className="col-8" style={{ padding: "0px 0px 0px 16px" }}>
                                <label htmlFor="TabView">{lang.program_group_sub_menu}</label>
                                <input name="Title" type="text" className="form-control form-control-sm" value={dataItem.ProgramGroup.Name} onChange={() => ""} disabled={true} />
                            </div>
                            <div className="col" style={{ padding: "0px 0px 0px 0px" }}>
                                <ActionButton
                                    style={{ marginTop: "18px", height: "30px" }}
                                    btnColor={'success'}
                                    title={lang.select_button_tooltip}
                                    name={"..."}
                                    onClick={() => { setOpenProgramGroupSelection(true) }}
                                />
                                <ActionButton style={{ marginTop: "18px", height: "30px" }} btnColor={'danger'} title={lang.select_button_tooltip} name={""} icon={'xmark'} onClick={() => setDataItem({ ...dataItem, ProgramGroup: { Name: "" } })} />
                            </div>
                        </div>
                        <p className="text-muted" style={{ fontSize: "9px", marginLeft: "20px", marginTop: "-3px" }}>{lang.program_group_episode_range_disable_note_message}</p>
                    </div>
                </div>
                <div className='col-6'>
                    <div style={{ margin: "0px 0px 0px 0px", height: "380px", border: '1px solid #c4c2c2', borderRadius: '5px!important' }}>
                        <div style={borderWithTitle}>&nbsp; {lang.exclusion_range_label} &nbsp;</div>
                        <div className='row mb-1 mr-1 ml-1'>
                            <div className='col-8'>
                                <input name={"ExcludeDays"} type={"Checkbox"} value={dataItem.ExcludeDays}
                                    onChange={onChange}
                                    style={{ textAlign: "left", marginRight: "5px" }} />
                                <span style={{ fontWeight: "normal", fontSize: "11px" }}>
                                    {lang.exclude_days_label}
                                </span>
                            </div>
                        </div>
                        <div className='row mr-1 ml-1'>
                            <div className='col-6'>
                                <div className="form-group">
                                    <label htmlFor="">{lang.from_date_label}</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="ExcludeFromDate"
                                        value={dataItem.ExcludeFromDate}
                                        onChange={onChange}
                                        disabled={!dataItem.ExcludeDays}
                                    />
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className="form-group">
                                    <label htmlFor="">{lang.to_date_label}</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="ExcludeToDate"
                                        value={dataItem.ExcludeToDate}
                                        onChange={onChange}
                                        disabled={!dataItem.ExcludeDays}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='row mr-1 ml-1'>
                            <div className='col-12'>
                                <div className="form-group">
                                    <span className="float-right">{lang.select_all_label}
                                        <input
                                            type={"checkbox"}
                                            name={"SelectAll"}
                                            className="ml-1"
                                            onChange={allDaySelect}
                                            checked={selectAllDays}
                                            value={selectAllDays}
                                            disabled={!dataItem.ExcludeDays}
                                        />
                                    </span>
                                    <label htmlFor="TabView">{lang.days_label}</label>
                                    <MultiSelect
                                        style={{
                                            backgroundColor: !dataItem.ExcludeDays ? '#E9ECEF' : "white",
                                        }}
                                        data={DAYS}
                                        name="ExclusionDays"
                                        textField="Name"
                                        dataItemKey="ID"
                                        value={dataItem.ExclusionDays}
                                        onChange={onChange}
                                        validator={(value) => value ? "" : "Please select the value"}
                                        disabled={!dataItem.ExcludeDays}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {!enableCreateRepPatFromRec ? <div className='row mt-1'>
                <div className="col-10" style={{ padding: "0px 0px 0px 16px" }}>
                    <div className="form-group">
                        <label htmlFor="TabView">{lang.repeat_pattern_label}</label>
                        <input name="Title" type="text" className="form-control form-control-sm" value={dataItem.RepeatPattern.Name} onChange={() => ""} disabled={true} />
                    </div>
                </div>
                <div className="col-2" style={{ padding: "0px 16px 0px 0px" }}>
                    <ActionButton style={{ marginTop: "18px", height: "30px" }} btnColor={'success'} title={lang.select_button_tooltip} name={"..."} onClick={onSelectRepeatPattern} />
                    <ActionButton style={{ marginTop: "18px", height: "30px" }} btnColor={'danger'} title={lang.select_button_tooltip} name={""} icon={'xmark'} onClick={() => setDataItem({ ...dataItem, RepeatPattern: { Name: "" } })} />
                </div>
            </div> :
                <div className="table-responsive mt-2 border p-1">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div>
                            <label htmlFor="TabView" style={{ fontSize: "15px" }}>{lang.repeat_pattern_label}</label>
                            <input type="checkbox" style={{ border: '1px solid grey', marginLeft: "5px" }} name={"showRepeatPattern"} checked={repeatPatternData.showRepeatPattern} value={repeatPatternData.showRepeatPattern} onChange={handleChange} />
                        </div>
                        <div>
                            {repeatPatternData.showRepeatPattern && <RoundButton icon={"save"} iconColor={"white"} title={"Save as Template"} btnColor={"primary"} onClick={onSaveAsTemplate} />}
                            {repeatPatternData.showRepeatPattern && <RoundButton icon={"folder-open"} iconColor={"white"} title={"Load from Template"} btnColor={"success"} onClick={onLoadFromTemplate} />}
                        </div>
                    </div>
                    {repeatPatternData.showRepeatPattern && (<>
                        <table className="table table-bordered align-middle table-sm mt-2" style={{ fontSize: '12px' }}>
                            <thead>
                                <tr>
                                    <th className="text-nowrap p-1" style={{ width: '40px' }}>Days</th>
                                    <th className="text-nowrap p-1" style={{ width: '98px' }}>Time</th>
                                    {timeBlocks.map((block, i) => (
                                        <React.Fragment key={i}>
                                            <th className="text-nowrap p-1 text-center" style={{ borderLeft: '2px solid gray', width: '98px' }}>
                                                Time {i + 1}
                                            </th>

                                            <th className="text-nowrap p-1 text-center" style={{ width: '50px' }}>
                                                <div>Repeat</div>
                                                <div className="mt-1">
                                                    <input
                                                        type="checkbox"
                                                        name={`SelectAllRepeat_block_${block}`}
                                                        style={{ border: '1px solid grey' }}
                                                        checked={repeatPatternData[`SelectAllRepeat_block_${block}`] || false}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </th>
                                            <th className="text-nowrap p-1 text-center" style={{ width: '60px' }}>
                                                <div>Next Day</div>
                                                <div className="mt-1">
                                                    <input
                                                        type="checkbox"
                                                        name={`SelectAllNextDay_block_${block}`}
                                                        style={{ border: '1px solid grey' }}
                                                        checked={repeatPatternData[`SelectAllNextDay_block_${block}`] || false}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {days.map((day) => (
                                    <tr key={day}>
                                        <td className="p-1">
                                            <div className="d-flex align-items-center">
                                                {/* <input
                                            type="checkbox"
                                            className="form-check-input me-1"
                                            style={{ width: '14px', height: '14px' }}
                                            name={`${day}_selected`}
                                            checked={repeatPatternData[`${day}_selected`] || false}
                                            onChange={handleChange}
                                            /> */}
                                                <label className="form-check-label m-0">{day}</label>
                                            </div>
                                        </td>
                                        <td className="p-1">
                                            <input
                                                type="text"
                                                name={`${day}time`}
                                                value={repeatPatternData[`${day}time`] || ""}
                                                onChange={handleTimeAutoFormat}
                                                style={{ width: '98px', padding: '0.1rem', paddingLeft: '10px', height: '22px', border: '1px solid lightgray', fontSize: '13px' }}
                                                placeholder="__:__"
                                                inputMode="numeric"
                                                maxLength={5}
                                            />
                                        </td>
                                        {timeBlocks.map((block, i) => (
                                            <React.Fragment key={`${day}_block${i}`}>
                                                <td className="p-1" style={{ borderLeft: '2px solid gray' }}>
                                                    <input
                                                        type="text"
                                                        name={`${day}_time_${block}`}
                                                        value={repeatPatternData[`${day}_time_${block}`] || ""}
                                                        onChange={handleTimeAutoFormat}
                                                        style={{ width: '98px', padding: '0.1rem', paddingLeft: '10px', height: '22px', border: '1px solid lightgray', fontSize: '13px' }}
                                                        placeholder="__:__"
                                                        inputMode="numeric"
                                                        maxLength={5}
                                                    />
                                                </td>
                                                <td className="text-center p-1">
                                                    <input
                                                        type="checkbox"
                                                        name={`${day}_repeat_${block}`}
                                                        checked={repeatPatternData[`${day}_repeat_${block}`] || false}
                                                        onChange={handleChange}
                                                        style={{ width: '14px', height: '12px' }}
                                                    />
                                                </td>
                                                <td className="text-center p-1">
                                                    <input
                                                        type="checkbox"
                                                        name={`${day}_nextDay_${block}`}
                                                        checked={repeatPatternData[`${day}_nextDay_${block}`] || false}
                                                        onChange={handleChange}
                                                        style={{ width: '14px', height: '12px' }}
                                                    />
                                                </td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className='mt-2 mb-2'>
                            <ActionButton title={lang.add_line_button_tooltip} name={lang.add_time_repeat_block_button} btnColor={'info'} onClick={() => setTimeBlocks([...timeBlocks, timeBlocks.length])} />
                            <ActionButton title={lang.clear_button_tooltip} name={lang.clear_button_text} btnColor={'danger'} onClick={() => setTimeBlocks([0, 1, 2])} />
                        </div>
                    </>)}
                </div>
            }

            {openRepeatPatternSelection && <CollectionSelection addButtonTitle={lang.select_button_text} title={lang.select_repeat_pattern_collection_header} entityname={ENTITYNAME.RepeatPattern} closeForm={() => setOpenRepeatPatternSelection(!openRepeatPatternSelection)} wherestatement={['Channel.SID', '=', props.selectedAppointment.ChannelSID]} setDataList={(dataList) => onSetSelectedRepeatPattern(dataList)} mode={'single'} width={"50vw"} showCreate={true} showSelfCreated={true} path={`/home/RepeatPattern`} />}

            {openProgramGroupSelection && (<CollectionSelection
                title={lang.select_program_group_label}
                entityname={ENTITYNAME.MediaEpisodeGroup}
                wherestatement={['MediaCategory.isLong', '=', true]}
                setDataList={onSetSelectedProgramGroup}
                mode={"single"}
                closeForm={() => { setOpenProgramGroupSelection(false) }}
            />)}
            {showRecursiveTemplatePopup.show && <RecursiveTemplatePopup
                onClose={() => setShowRecursiveTemplatePopup({ show: false, forLoad: false, data: null })}
                forLoad={showRecursiveTemplatePopup.forLoad}
                data={showRecursiveTemplatePopup.data}
                onRecursiveTemplateSelect={onRecursiveTemplateSelect}
            />}
        </BossDialog>
    )
});
